import * as i0 from '@angular/core';
import { Input, Host, Directive, ViewContainerRef, forwardRef, ViewChild, Component, Pipe, EventEmitter, Output, NgModule } from '@angular/core';
import * as i2 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import * as i4 from '@engineering11/ui-lib/e11-input-errors';
import { Validation, E11InputErrorsModule } from '@engineering11/ui-lib/e11-input-errors';
import { E11TemplateMap, E11UtilModule } from '@engineering11/ui-lib/e11-ui-utils';
import { debounceTime } from 'rxjs';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3$1 from '@engineering11/ui-lib/e11-button';
import { E11ButtonModule } from '@engineering11/ui-lib/e11-button';
import * as i3 from '@engineering11/ui-lib/e11-input';
import { E11InputModule } from '@engineering11/ui-lib/e11-input';
import * as i5 from '@engineering11/ui-lib/e11-input-checkbox';
import { E11InputCheckboxModule } from '@engineering11/ui-lib/e11-input-checkbox';
import * as i6 from '@engineering11/ui-lib/e11-radio-input';
import { E11RadioInputModule } from '@engineering11/ui-lib/e11-radio-input';
import * as i7 from '@engineering11/ui-lib/e11-select';
import { E11SelectModule } from '@engineering11/ui-lib/e11-select';
import * as i8 from '@engineering11/ui-lib/e11-input-code';
import { E11InputCodeModule } from '@engineering11/ui-lib/e11-input-code';
import * as i9 from '@engineering11/ui-lib/e11-phone-number';
import { E11PhoneNumberModule } from '@engineering11/ui-lib/e11-phone-number';
import * as i10 from '@engineering11/ui-lib/e11-multi-select';
import { E11MultiSelectModule } from '@engineering11/ui-lib/e11-multi-select';
import * as i11 from '@engineering11/ui-lib/e11-multi-selector';
import { E11MultiSelectorModule } from '@engineering11/ui-lib/e11-multi-selector';
import * as i12 from '@engineering11/ui-lib/e11-autocomplete';
import { E11AutocompleteModule } from '@engineering11/ui-lib/e11-autocomplete';
import * as i13 from '@engineering11/ui-lib/e11-switch';
import { E11SwitchModule } from '@engineering11/ui-lib/e11-switch';
import * as i14 from '@engineering11/ui-lib/e11-textarea';
import { E11TextareaModule } from '@engineering11/ui-lib/e11-textarea';
import * as i15 from '@engineering11/ui-lib/e11-input-file';
import { E11InputFileModule } from '@engineering11/ui-lib/e11-input-file';
import * as i16 from '@engineering11/ui-lib/e11-survey';
import { E11SurveyScoreComponent, E11SurveySelectorComponent } from '@engineering11/ui-lib/e11-survey';
import * as i17 from '@engineering11/ui-lib/e11-date-picker';
import { E11DatePickerModule } from '@engineering11/ui-lib/e11-date-picker';
import * as i18 from '@engineering11/ui-lib/e11-inline-select';
import { E11InlineSelectComponent } from '@engineering11/ui-lib/e11-inline-select';
import { isArray } from '@engineering11/utility';
import { E11ModalModule } from '@engineering11/ui-lib/e11-modal';

const SUBMIT_BUTTON_DEFAULT_CONFIG = { value: 'Save', color: 'primary-accent', size: 'md', loading: false };
const CANCEL_BUTTON_DEFAULT_CONFIG = { value: 'Cancel', color: 'neutral', ghost: true, size: 'md', show: false };
const DELETE_BUTTON_DEFAULT_CONFIG = { value: 'Delete', color: 'secondary', ghost: true, size: 'md', show: false };
const CANCEL_LINK_DEFAULT_CONFIG = { value: 'Cancel', show: false };

class SwitchCasesDirective {
    constructor(viewContainer, templateRef, ngSwitch) {
        this.viewContainer = viewContainer;
        this.templateRef = templateRef;
        this._created = false;
        this.jrSwitchCases = [];
        this.ngSwitch = ngSwitch;
    }
    ngOnInit() {
        ;
        (this.jrSwitchCases || []).forEach(() => this.ngSwitch._addCase());
    }
    ngDoCheck() {
        let enforce = false;
        (this.jrSwitchCases || []).forEach((value) => (enforce = this.ngSwitch._matchCase(value) || enforce));
        this.enforceState(enforce);
    }
    enforceState(created) {
        if (created && !this._created) {
            this._created = true;
            this.viewContainer.createEmbeddedView(this.templateRef);
        }
        else if (!created && this._created) {
            this._created = false;
            this.viewContainer.clear();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SwitchCasesDirective, deps: [{ token: i0.ViewContainerRef }, { token: i0.TemplateRef }, { token: i1.NgSwitch, host: true }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.13", type: SwitchCasesDirective, selector: "[jrSwitchCases]", inputs: { jrSwitchCases: "jrSwitchCases" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SwitchCasesDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[jrSwitchCases]',
                }]
        }], ctorParameters: () => [{ type: i0.ViewContainerRef }, { type: i0.TemplateRef }, { type: i1.NgSwitch, decorators: [{
                    type: Host
                }] }], propDecorators: { jrSwitchCases: [{
                type: Input
            }] } });

/**
 * This component is used to dynamically generate a component based on the input component type
 * This is useful for creating dynamic forms where the form elements are not known at compile time
 *
 */
class E11DynamicComponentGeneratorComponent {
    constructor() {
        this._loading = false;
        this.onChange = () => { };
        this.onTouched = () => { };
        this.isDisabled = false;
    }
    /** Skeleton load the component */
    set loading(loading) {
        this._loading = loading ?? false;
        if (!this.componentRef)
            return;
        this.componentRef.instance.loading = this._loading;
    }
    /**
     *
     * @param obj The value to be written to the component
     */
    writeValue(obj) {
        this.value = obj;
        if (this.componentRef) {
            this.componentRef.instance.writeValue(obj);
        }
    }
    /**
     *
     * @param fn The function to be called when the value changes
     */
    registerOnChange(fn) {
        this.onChange = fn;
        if (this.componentRef) {
            this.componentRef.instance.registerOnChange(fn);
        }
    }
    /**
     *
     * @param fn The function to be called when the component is touched
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
        if (this.componentRef) {
            this.componentRef.instance.registerOnTouched(fn);
        }
    }
    /**
     *
     * @param isDisabled Whether the component should be disabled
     */
    setDisabledState(isDisabled) {
        this.isDisabled = isDisabled;
        if (this.componentRef) {
            this.componentRef.instance.setDisabledState?.(isDisabled);
        }
    }
    ngAfterViewInit() {
        // Create the component
        this.componentRef = this.dynamicComponentPlaceholder.createComponent(this.component);
        // Ensure the instance methods are registered
        this.componentRef.instance.registerOnChange(this.onChange);
        this.componentRef.instance.registerOnTouched(this.onTouched);
        this.componentRef.instance.setDisabledState?.(this.isDisabled);
        this.componentRef.instance.loading = this._loading;
        // Set the initial value if it exists
        if (this.value !== undefined) {
            this.componentRef.instance.writeValue(this.value);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11DynamicComponentGeneratorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: E11DynamicComponentGeneratorComponent, selector: "e11-dynamic-component-generator", inputs: { component: "component", loading: "loading" }, providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => E11DynamicComponentGeneratorComponent), multi: true }], viewQueries: [{ propertyName: "dynamicComponentPlaceholder", first: true, predicate: ["dynamicComponentPlaceholder"], descendants: true, read: ViewContainerRef }], ngImport: i0, template: `<ng-template #dynamicComponentPlaceholder></ng-template>`, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11DynamicComponentGeneratorComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'e11-dynamic-component-generator',
                    template: `<ng-template #dynamicComponentPlaceholder></ng-template>`,
                    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => E11DynamicComponentGeneratorComponent), multi: true }],
                }]
        }], propDecorators: { component: [{
                type: Input,
                args: [{ required: true }]
            }], loading: [{
                type: Input
            }], dynamicComponentPlaceholder: [{
                type: ViewChild,
                args: ['dynamicComponentPlaceholder', { read: ViewContainerRef }]
            }] } });

class E11FieldBuilderComponent {
    get isValid() {
        return this.form.controls[this.field.name].valid;
    }
    get isDirty() {
        return this.form.controls[this.field.name].dirty;
    }
    constructor() {
        this.loading = false;
        this.disabled = false;
        this.disabledText = 'This field is disabled';
    }
    ngOnInit() { }
    ngAfterViewInit() {
        if (!this.field.extraInputOption)
            return;
        this.e11InputPassThroughAPI();
    }
    e11InputPassThroughAPI() {
        const setInputForDirectAPIItems = (component, key, value) => {
            component[key] = value;
        };
        Object.keys(this.field.extraInputOption || {}).forEach((key) => {
            const inputType = this.getInputType(this.field.inputType);
            if (!inputType)
                return;
            if (this.field.inputType === 'dynamic' &&
                this.e11InputDynamic?.componentRef &&
                this.field.extraInputOption[key]) {
                //@ts-ignore
                this.e11InputDynamic.componentRef.instance[key] =
                    this.field.extraInputOption[key];
                return;
            }
            setInputForDirectAPIItems(inputType, key, this.field.extraInputOption[key]);
        });
    }
    getInputType(inputType) {
        const inputTypeMap = {
            text: this.e11Input,
            number: this.e11Input,
            color: this.e11Input,
            url: this.e11Input,
            select: this.e11InputSelect,
            radio: this.e11InputRadio,
            checkbox: this.e11InputCheckBox,
            code: this.e11InputCode,
            phone: this.e11InputPhone,
            multiSelect: this.e11InputMultiSelect,
            multiSelector: this.e11InputMultiSelector,
            surveySelector: this.e11SurveySelector,
            autocomplete: this.e11Autocomplete,
            switch: this.e11Switch,
            textarea: this.e11TextArea,
            file: this.e11InputFile,
            surveyScore: this.e11SurveyScore,
            datePicker: this.e11InputDatePicker,
            dynamic: this.e11InputDynamic,
            inlineSelect: this.e11InlineInputSelect,
        };
        const component = inputTypeMap[inputType];
        if (!component)
            throw new Error(`Invalid input type: ${inputType}`);
        return component;
    }
    get f() {
        return this.form.controls;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11FieldBuilderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: E11FieldBuilderComponent, selector: "e11-field-builder", inputs: { field: "field", form: "form", loading: "loading", disabled: "disabled", disabledText: "disabledText", errorMessageOverrides: "errorMessageOverrides" }, viewQueries: [{ propertyName: "e11Input", first: true, predicate: ["e11Input"], descendants: true }, { propertyName: "e11InputRadio", first: true, predicate: ["e11InputRadio"], descendants: true }, { propertyName: "e11InputSelect", first: true, predicate: ["e11InputSelect"], descendants: true }, { propertyName: "e11InlineInputSelect", first: true, predicate: ["e11InlineInputSelect"], descendants: true }, { propertyName: "e11InputMultiSelect", first: true, predicate: ["e11InputMultiSelect"], descendants: true }, { propertyName: "e11InputMultiSelector", first: true, predicate: ["e11InputMultiSelector"], descendants: true }, { propertyName: "e11SurveySelector", first: true, predicate: ["e11SurveySelector"], descendants: true }, { propertyName: "e11InputCheckBox", first: true, predicate: ["e11InputCheckBox"], descendants: true }, { propertyName: "e11InputCode", first: true, predicate: ["e11InputCode"], descendants: true }, { propertyName: "e11InputPhone", first: true, predicate: ["e11InputPhone"], descendants: true }, { propertyName: "e11Autocomplete", first: true, predicate: ["e11Autocomplete"], descendants: true }, { propertyName: "e11Switch", first: true, predicate: ["e11Switch"], descendants: true }, { propertyName: "e11TextArea", first: true, predicate: ["e11TextArea"], descendants: true }, { propertyName: "e11InputFile", first: true, predicate: ["e11InputFile"], descendants: true }, { propertyName: "e11InputDatePicker", first: true, predicate: ["e11InputDatePicker"], descendants: true }, { propertyName: "e11InputDynamic", first: true, predicate: ["e11InputDynamic"], descendants: true }, { propertyName: "e11SurveyScore", first: true, predicate: ["e11SurveyScore"], descendants: true }], ngImport: i0, template: "<div class=\"\" [formGroup]=\"form\">\n  <div class=\"\" [ngSwitch]=\"field.inputType\">\n    <ng-container *jrSwitchCases=\"['text', 'color', 'number', 'url']\">\n      <e11-input\n        #e11Input\n        [type]=\"field.inputType\"\n        [label]=\"field.label\"\n        [name]=\"field.name\"\n        [parentForm]=\"form\"\n        [formControlName]=\"field.name\"\n        [loading]=\"loading\"\n        [disabled]=\"disabled\"\n        [disabledText]=\"disabledText\"\n      >\n      </e11-input>\n      <e11-input-errors\n        *ngIf=\"!field.hideInputError\"\n        [formControl]=\"f[field.name]\"\n        [parentForm]=\"form\"\n        [messageOverrides]=\"errorMessageOverrides\"\n      ></e11-input-errors>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'select'\">\n      <e11-select\n        *ngIf=\"field.inputType === 'select'\"\n        #e11InputSelect\n        [label]=\"field.label\"\n        [parentForm]=\"form\"\n        [formControlName]=\"field.name\"\n        [options]=\"field.options || []\"\n        [loading]=\"loading\"\n        [disabled]=\"disabled\"\n      >\n      </e11-select>\n      <e11-input-errors\n        *ngIf=\"!field.hideInputError\"\n        [formControl]=\"f[field.name]\"\n        [parentForm]=\"form\"\n        [messageOverrides]=\"errorMessageOverrides\"\n      ></e11-input-errors>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'inlineSelect'\">\n      <e11-inline-select\n        *ngIf=\"field.inputType === 'inlineSelect'\"\n        #e11InlineInputSelect\n        [label]=\"field.label\"\n        [parentForm]=\"form\"\n        [formControlName]=\"field.name\"\n        [options]=\"field.options || []\"\n        [loading]=\"loading\"\n        [disabled]=\"disabled\"\n      >\n      </e11-inline-select>\n      <e11-input-errors\n        *ngIf=\"!field.hideInputError\"\n        [formControl]=\"f[field.name]\"\n        [parentForm]=\"form\"\n        [messageOverrides]=\"errorMessageOverrides\"\n      ></e11-input-errors>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'multiSelect'\">\n      <e11-multi-select\n        *ngIf=\"field.inputType === 'multiSelect'\"\n        #e11InputMultiSelect\n        [label]=\"field.label\"\n        [parentForm]=\"form\"\n        [options]=\"field.options || []\"\n        [formControlName]=\"field.name\"\n        [loading]=\"loading\"\n        [disabled]=\"disabled\"\n      >\n      </e11-multi-select>\n      <e11-input-errors\n        *ngIf=\"!field.hideInputError\"\n        [formControl]=\"f[field.name]\"\n        [parentForm]=\"form\"\n        [messageOverrides]=\"errorMessageOverrides\"\n      ></e11-input-errors>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'multiSelector'\">\n      <e11-multi-selector\n        *ngIf=\"field.inputType === 'multiSelector'\"\n        #e11InputMultiSelector\n        [label]=\"field.label\"\n        [parentForm]=\"form\"\n        [options]=\"field.options || []\"\n        [formControlName]=\"field.name\"\n        [loading]=\"loading\"\n        [disabled]=\"disabled\"\n      >\n      </e11-multi-selector>\n      <e11-input-errors\n        *ngIf=\"!field.hideInputError\"\n        [formControl]=\"f[field.name]\"\n        [parentForm]=\"form\"\n        [messageOverrides]=\"errorMessageOverrides\"\n      ></e11-input-errors>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"'surveySelector'\">\n      <e11-survey-selector\n        *ngIf=\"field.inputType === 'surveySelector'\"\n        #e11SurveySelector\n        [parentForm]=\"form\"\n        [question]=\"field.options?.[0]\"\n        [formControlName]=\"field.name\"\n        [loading]=\"loading\"\n        [disabled]=\"disabled\"\n      >\n      </e11-survey-selector>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"'code'\">\n      <e11-input-code #e11InputCode [label]=\"field.label\" [formControlName]=\"field.name\" [parentForm]=\"form\"> </e11-input-code>\n      <e11-input-errors\n        *ngIf=\"!field.hideInputError\"\n        [formControl]=\"f[field.name]\"\n        [parentForm]=\"form\"\n        [messageOverrides]=\"errorMessageOverrides\"\n      ></e11-input-errors>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'checkbox'\">\n      <e11-input-checkbox-group\n        *ngIf=\"field.inputType === 'checkbox'\"\n        #e11InputCheckBox\n        [groupLabel]=\"field.label\"\n        [options]=\"field.options || []\"\n        [parentFormGroup]=\"form\"\n        [loading]=\"loading\"\n        [disabled]=\"disabled\"\n        [disabledText]=\"disabledText\"\n      >\n      </e11-input-checkbox-group>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'radio'\">\n      <e11-radio-group-input\n        *ngIf=\"field.inputType === 'radio'\"\n        #e11InputRadio\n        [parentFormGroup]=\"form\"\n        [options]=\"field.options || []\"\n        [groupLabel]=\"field.label\"\n        [groupName]=\"field.name\"\n        [loading]=\"loading\"\n        [disabled]=\"disabled\"\n        [disabledText]=\"disabledText\"\n      >\n      </e11-radio-group-input>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'datePicker'\">\n      <e11-date-picker\n        *ngIf=\"field.inputType === 'datePicker'\"\n        #e11InputDatePicker\n        [parentForm]=\"form\"\n        [formControlName]=\"field.name\"\n        [label]=\"field.label\"\n        [loading]=\"loading\"\n        [inputDate]=\"f[field.name].value\"\n        [disabled]=\"disabled\"\n      >\n      </e11-date-picker>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"'phone'\">\n      <e11-phone-number\n        #e11InputPhone\n        [label]=\"field.label\"\n        [formControlName]=\"field.name\"\n        [parentForm]=\"form\"\n        [loading]=\"loading\"\n        [disabled]=\"disabled\"\n      >\n      </e11-phone-number>\n      <e11-input-errors\n        *ngIf=\"!field.hideInputError\"\n        [formControl]=\"f[field.name]\"\n        [parentForm]=\"form\"\n        [messageOverrides]=\"errorMessageOverrides\"\n      ></e11-input-errors>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"'autocomplete'\">\n      <e11-autocomplete\n        *ngIf=\"field.inputType === 'autocomplete'\"\n        #e11Autocomplete\n        [data]=\"field.options || []\"\n        [label]=\"field.label\"\n        [formControlName]=\"field.name\"\n        [parentForm]=\"form\"\n        [skeletonLoading]=\"loading\"\n        [disabled]=\"disabled\"\n        [itemTemplate]=\"itemTemplate\"\n      >\n      </e11-autocomplete>\n      <ng-template #itemTemplate let-item>\n        <a [innerHTML]=\"$any(field.extraInputOption)?.searchKeyword ? item[$any(field.extraInputOption)?.searchKeyword] : item\"></a>\n      </ng-template>\n      <e11-input-errors\n        *ngIf=\"!field.hideInputError\"\n        [formControl]=\"f[field.name]\"\n        [parentForm]=\"form\"\n        [messageOverrides]=\"errorMessageOverrides\"\n      ></e11-input-errors>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"'switch'\">\n      <e11-switch\n        *ngIf=\"field.inputType === 'switch'\"\n        #e11Switch\n        [checked]=\"f[field.name].value\"\n        (changes)=\"f[field.name].setValue($event)\"\n        [label]=\"field.label\"\n        [disabled]=\"disabled\"\n        [disabledText]=\"disabledText\"\n        [size]=\"'sm'\"\n        [loading]=\"loading\"\n      >\n      </e11-switch>\n      <e11-input-errors\n        *ngIf=\"!field.hideInputError\"\n        [formControl]=\"f[field.name]\"\n        [parentForm]=\"form\"\n        [messageOverrides]=\"errorMessageOverrides\"\n      ></e11-input-errors>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"'textarea'\">\n      <e11-textarea\n        #e11TextArea\n        *ngIf=\"field.inputType === 'textarea'\"\n        [label]=\"field.label\"\n        [parentForm]=\"form\"\n        [formControlName]=\"field.name\"\n        [loading]=\"loading\"\n      ></e11-textarea>\n      <e11-input-errors\n        *ngIf=\"!field.hideInputError\"\n        [formControl]=\"f[field.name]\"\n        [parentForm]=\"form\"\n        [messageOverrides]=\"errorMessageOverrides\"\n      ></e11-input-errors>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'file'\">\n      <e11-input-file\n        #e11InputFile\n        *ngIf=\"field.inputType === 'file'\"\n        [formControlName]=\"field.name\"\n        [label]=\"field.label\"\n        [disabled]=\"disabled\"\n        [parentForm]=\"form\"\n        [loading]=\"loading\"\n      ></e11-input-file>\n      <e11-input-errors\n        *ngIf=\"!field.hideInputError\"\n        [formControl]=\"f[field.name]\"\n        [parentForm]=\"form\"\n        [messageOverrides]=\"errorMessageOverrides\"\n      ></e11-input-errors>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'surveyScore'\">\n      <e11-survey-score\n        *ngIf=\"field.inputType === 'surveyScore'\"\n        #e11SurveyScore\n        [parentForm]=\"form\"\n        [question]=\"field.options?.[0]\"\n        [formControlName]=\"field.name\"\n        [loading]=\"loading\"\n        [disabled]=\"disabled\"\n      >\n      </e11-survey-score>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"'dynamic'\">\n      <e11-dynamic-component-generator\n        #e11InputDynamic\n        *ngIf=\"field.inputType === 'dynamic'\"\n        [component]=\"field.extraInputOption!.component!\"\n        [formControlName]=\"field.name\"\n        [loading]=\"loading\"\n      ></e11-dynamic-component-generator>\n    </ng-container>\n  </div>\n  <!-- <ng-container *ngIf=\"field.nestedFormFields\" > -->\n  <e11-field-builder\n    *ngFor=\"let nestedField of field.nestedFormFields\"\n    [field]=\"nestedField\"\n    [form]=\"form\"\n    [loading]=\"loading\"\n    [disabled]=\"disabled\"\n    [disabledText]=\"disabledText\"\n  ></e11-field-builder>\n  <!-- </ng-container> -->\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i3.E11InputComponent, selector: "e11-input", inputs: ["containerClass", "inputClass", "hintText", "label", "type", "size", "style", "placeholder", "maxLength", "max", "name", "id", "iconLeft", "iconLeftBorder", "required", "hasError", "labelColor", "borderGlow", "checkIcon", "clearIcon", "autofocus", "togglePassword", "hasButton", "buttonText", "buttonIcon", "buttonIconType", "buttonIconSize", "readonly", "disabled", "disabledText", "autocomplete", "formControlName", "isRounded", "parentForm", "tooltipConfig", "icon", "iconType", "iconSize", "darkMode", "context", "enforceCharacterLimit", "showCharacterLimitWarning", "loading", "leadingIcon", "trailingIcon"], outputs: ["change", "focus", "blur"] }, { kind: "component", type: i4.E11InputErrorsComponent, selector: "e11-input-errors", inputs: ["formControl", "parentForm", "label", "formSubmitted", "suppressError", "messageOverrides"] }, { kind: "component", type: i5.E11CheckboxGroupComponent, selector: "e11-input-checkbox-group", inputs: ["errorMessageOverrides", "loading", "disabled", "required", "disabledText", "containerClass", "fieldClass", "groupLabel", "parentFormGroup", "options", "showResetButton", "resetButtonLabel", "tooltipConfig"] }, { kind: "component", type: i6.E11RadioGroupComponent, selector: "e11-radio-group-input", inputs: ["errorMessageOverrides", "loading", "disabled", "required", "disabledText", "containerClass", "fieldClass", "groupLabel", "groupName", "parentFormGroup", "options", "tooltipConfig"] }, { kind: "component", type: i7.E11SelectComponent, selector: "e11-select", inputs: ["id", "name", "label", "size", "selectMessage", "labelClass", "inputClass", "containerClass", "parentForm", "formControlName", "options", "value", "hasError", "required", "disabled", "loading", "tooltipConfig", "labelTextOptional", "selectClass"], outputs: ["valueChange", "onValueChange"] }, { kind: "component", type: i8.E11InputCodeComponent, selector: "e11-input-code", inputs: ["value", "parentForm", "formControlName", "label", "containerClass", "hasError", "required", "disabled", "tooltipConfig", "labelTextOptional"], outputs: ["cursorActivity", "focusChange", "scroll", "drop", "codeMirrorLoaded", "change"] }, { kind: "component", type: i9.E11PhoneNumberComponent, selector: "e11-phone-number", inputs: ["label", "id", "placeholder", "inputClass", "hasError", "disabled", "labelClass", "value", "country", "countryCodes", "showCountrySearch", "shouldValidate", "required", "labelSize", "formControlName", "parentForm", "loading", "tooltipConfig", "labelTextOptional"], outputs: ["valueUpdated"] }, { kind: "component", type: i10.E11MultiSelectComponent, selector: "e11-multi-select", inputs: ["id", "name", "label", "selectMessage", "labelClassOverrides", "checkboxClassOverrides", "inputClass", "containerClass", "parentForm", "formControlName", "options", "value", "hasError", "required", "disabled", "loading", "tooltipConfig", "labelTextOptional", "searchable", "searchResultsEmpty", "isDropdownSelect", "dropdownContainerClass", "inputClassOverrides"], outputs: ["valueChange"] }, { kind: "component", type: i11.E11MultiSelectorComponent, selector: "e11-multi-selector", inputs: ["id", "name", "label", "labelClassOverrides", "inputClass", "containerClass", "parentForm", "formControlName", "options", "value", "hasError", "required", "disabled", "loading", "multi", "tooltipConfig", "labelTextOptional", "color"], outputs: ["valueChange"] }, { kind: "component", type: i12.E11AutocompleteComponent, selector: "e11-autocomplete", inputs: ["name", "label", "placeholder", "heading", "required", "initialValue", "data", "selectedData", "searchKeyword", "isMultiSelect", "notFoundText", "isLoading", "skeletonLoading", "debounceTime", "disabled", "minQueryLength", "focusFirst", "stopSelectEvent", "customFilter", "formControlName", "parentForm", "hasError", "itemTemplate", "notFoundTemplate"], outputs: ["selected", "inputChanged", "inputFocused", "inputCleared", "opened", "closed", "scrolledToEnd"] }, { kind: "component", type: i13.E11SwitchComponent, selector: "e11-switch", inputs: ["id", "size", "color", "label", "containerClassOverrides", "containerClass", "disabled", "disabledText", "checked", "loading", "spinnerLoading"], outputs: ["changes", "onChange", "changeEvent", "OnchangeEvent"] }, { kind: "component", type: i14.E11TextareaComponent, selector: "e11-textarea", inputs: ["name", "id", "cols", "rows", "label", "required", "labelColor", "borderGlow", "readonly", "disabled", "disabledText", "hasError", "parentForm", "placeholder", "darkMode", "maxLength", "context", "enforceCharacterLimit", "showCharacterLimitWarning", "formControlName", "containerClass", "inputClass", "loading", "tooltipConfig", "labelTextOptional"], outputs: ["change", "focus", "blur"] }, { kind: "component", type: i15.E11InputFileComponent, selector: "e11-input-file", inputs: ["multi", "errorMessage", "validateFile", "autoCrop", "label", "formControlName", "parentForm", "hasError", "required", "disabled", "loading", "accept", "labelClassOverrides", "inputClass", "containerClass", "tooltipConfig", "labelTextOptional", "defaultPreviewUrls", "id"] }, { kind: "component", type: i16.E11SurveyScoreComponent, selector: "e11-survey-score", inputs: ["question", "emptyLabel", "parentForm", "formControlName", "disabled", "required", "hasError", "loading", "containerClass", "inputClass", "labelClass", "defaultValues"], outputs: ["valueChange"] }, { kind: "component", type: i16.E11SurveySelectorComponent, selector: "e11-survey-selector", inputs: ["question", "containerClass", "inputClass", "labelClass", "buttonClass", "defaultValue", "parentForm", "formControlName", "hasError", "required", "disabled", "loading", "multi", "size"], outputs: ["valueChange"] }, { kind: "component", type: i17.E11DatePickerComponent, selector: "e11-date-picker", inputs: ["color", "loading", "inputDate", "value", "format", "min", "monthAndYearFormat", "formattedValue", "hideOnSelect", "inputMessage", "type", "selectYearsRange", "maxYearSelectable", "minYearSelectable", "minDate", "parentForm", "formControlName", "classOverride", "label", "required", "id", "showLeadingIcon", "showTrailingIcon", "hasError", "locale", "numberOfMonths", "firstMonth", "firstDayOfWeek"], outputs: ["valueChange"] }, { kind: "component", type: i18.E11InlineSelectComponent, selector: "e11-inline-select", inputs: ["label", "value", "options", "placeholder", "id", "loading", "editing", "required", "editIcon", "hasError", "size", "tooltipConfig", "requiredTooltipConfig", "formControlName", "parentForm"], outputs: ["inputSaved", "inputChange"] }, { kind: "component", type: E11FieldBuilderComponent, selector: "e11-field-builder", inputs: ["field", "form", "loading", "disabled", "disabledText", "errorMessageOverrides"] }, { kind: "directive", type: SwitchCasesDirective, selector: "[jrSwitchCases]", inputs: ["jrSwitchCases"] }, { kind: "component", type: E11DynamicComponentGeneratorComponent, selector: "e11-dynamic-component-generator", inputs: ["component", "loading"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11FieldBuilderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'e11-field-builder', template: "<div class=\"\" [formGroup]=\"form\">\n  <div class=\"\" [ngSwitch]=\"field.inputType\">\n    <ng-container *jrSwitchCases=\"['text', 'color', 'number', 'url']\">\n      <e11-input\n        #e11Input\n        [type]=\"field.inputType\"\n        [label]=\"field.label\"\n        [name]=\"field.name\"\n        [parentForm]=\"form\"\n        [formControlName]=\"field.name\"\n        [loading]=\"loading\"\n        [disabled]=\"disabled\"\n        [disabledText]=\"disabledText\"\n      >\n      </e11-input>\n      <e11-input-errors\n        *ngIf=\"!field.hideInputError\"\n        [formControl]=\"f[field.name]\"\n        [parentForm]=\"form\"\n        [messageOverrides]=\"errorMessageOverrides\"\n      ></e11-input-errors>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'select'\">\n      <e11-select\n        *ngIf=\"field.inputType === 'select'\"\n        #e11InputSelect\n        [label]=\"field.label\"\n        [parentForm]=\"form\"\n        [formControlName]=\"field.name\"\n        [options]=\"field.options || []\"\n        [loading]=\"loading\"\n        [disabled]=\"disabled\"\n      >\n      </e11-select>\n      <e11-input-errors\n        *ngIf=\"!field.hideInputError\"\n        [formControl]=\"f[field.name]\"\n        [parentForm]=\"form\"\n        [messageOverrides]=\"errorMessageOverrides\"\n      ></e11-input-errors>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'inlineSelect'\">\n      <e11-inline-select\n        *ngIf=\"field.inputType === 'inlineSelect'\"\n        #e11InlineInputSelect\n        [label]=\"field.label\"\n        [parentForm]=\"form\"\n        [formControlName]=\"field.name\"\n        [options]=\"field.options || []\"\n        [loading]=\"loading\"\n        [disabled]=\"disabled\"\n      >\n      </e11-inline-select>\n      <e11-input-errors\n        *ngIf=\"!field.hideInputError\"\n        [formControl]=\"f[field.name]\"\n        [parentForm]=\"form\"\n        [messageOverrides]=\"errorMessageOverrides\"\n      ></e11-input-errors>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'multiSelect'\">\n      <e11-multi-select\n        *ngIf=\"field.inputType === 'multiSelect'\"\n        #e11InputMultiSelect\n        [label]=\"field.label\"\n        [parentForm]=\"form\"\n        [options]=\"field.options || []\"\n        [formControlName]=\"field.name\"\n        [loading]=\"loading\"\n        [disabled]=\"disabled\"\n      >\n      </e11-multi-select>\n      <e11-input-errors\n        *ngIf=\"!field.hideInputError\"\n        [formControl]=\"f[field.name]\"\n        [parentForm]=\"form\"\n        [messageOverrides]=\"errorMessageOverrides\"\n      ></e11-input-errors>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'multiSelector'\">\n      <e11-multi-selector\n        *ngIf=\"field.inputType === 'multiSelector'\"\n        #e11InputMultiSelector\n        [label]=\"field.label\"\n        [parentForm]=\"form\"\n        [options]=\"field.options || []\"\n        [formControlName]=\"field.name\"\n        [loading]=\"loading\"\n        [disabled]=\"disabled\"\n      >\n      </e11-multi-selector>\n      <e11-input-errors\n        *ngIf=\"!field.hideInputError\"\n        [formControl]=\"f[field.name]\"\n        [parentForm]=\"form\"\n        [messageOverrides]=\"errorMessageOverrides\"\n      ></e11-input-errors>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"'surveySelector'\">\n      <e11-survey-selector\n        *ngIf=\"field.inputType === 'surveySelector'\"\n        #e11SurveySelector\n        [parentForm]=\"form\"\n        [question]=\"field.options?.[0]\"\n        [formControlName]=\"field.name\"\n        [loading]=\"loading\"\n        [disabled]=\"disabled\"\n      >\n      </e11-survey-selector>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"'code'\">\n      <e11-input-code #e11InputCode [label]=\"field.label\" [formControlName]=\"field.name\" [parentForm]=\"form\"> </e11-input-code>\n      <e11-input-errors\n        *ngIf=\"!field.hideInputError\"\n        [formControl]=\"f[field.name]\"\n        [parentForm]=\"form\"\n        [messageOverrides]=\"errorMessageOverrides\"\n      ></e11-input-errors>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'checkbox'\">\n      <e11-input-checkbox-group\n        *ngIf=\"field.inputType === 'checkbox'\"\n        #e11InputCheckBox\n        [groupLabel]=\"field.label\"\n        [options]=\"field.options || []\"\n        [parentFormGroup]=\"form\"\n        [loading]=\"loading\"\n        [disabled]=\"disabled\"\n        [disabledText]=\"disabledText\"\n      >\n      </e11-input-checkbox-group>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'radio'\">\n      <e11-radio-group-input\n        *ngIf=\"field.inputType === 'radio'\"\n        #e11InputRadio\n        [parentFormGroup]=\"form\"\n        [options]=\"field.options || []\"\n        [groupLabel]=\"field.label\"\n        [groupName]=\"field.name\"\n        [loading]=\"loading\"\n        [disabled]=\"disabled\"\n        [disabledText]=\"disabledText\"\n      >\n      </e11-radio-group-input>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'datePicker'\">\n      <e11-date-picker\n        *ngIf=\"field.inputType === 'datePicker'\"\n        #e11InputDatePicker\n        [parentForm]=\"form\"\n        [formControlName]=\"field.name\"\n        [label]=\"field.label\"\n        [loading]=\"loading\"\n        [inputDate]=\"f[field.name].value\"\n        [disabled]=\"disabled\"\n      >\n      </e11-date-picker>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"'phone'\">\n      <e11-phone-number\n        #e11InputPhone\n        [label]=\"field.label\"\n        [formControlName]=\"field.name\"\n        [parentForm]=\"form\"\n        [loading]=\"loading\"\n        [disabled]=\"disabled\"\n      >\n      </e11-phone-number>\n      <e11-input-errors\n        *ngIf=\"!field.hideInputError\"\n        [formControl]=\"f[field.name]\"\n        [parentForm]=\"form\"\n        [messageOverrides]=\"errorMessageOverrides\"\n      ></e11-input-errors>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"'autocomplete'\">\n      <e11-autocomplete\n        *ngIf=\"field.inputType === 'autocomplete'\"\n        #e11Autocomplete\n        [data]=\"field.options || []\"\n        [label]=\"field.label\"\n        [formControlName]=\"field.name\"\n        [parentForm]=\"form\"\n        [skeletonLoading]=\"loading\"\n        [disabled]=\"disabled\"\n        [itemTemplate]=\"itemTemplate\"\n      >\n      </e11-autocomplete>\n      <ng-template #itemTemplate let-item>\n        <a [innerHTML]=\"$any(field.extraInputOption)?.searchKeyword ? item[$any(field.extraInputOption)?.searchKeyword] : item\"></a>\n      </ng-template>\n      <e11-input-errors\n        *ngIf=\"!field.hideInputError\"\n        [formControl]=\"f[field.name]\"\n        [parentForm]=\"form\"\n        [messageOverrides]=\"errorMessageOverrides\"\n      ></e11-input-errors>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"'switch'\">\n      <e11-switch\n        *ngIf=\"field.inputType === 'switch'\"\n        #e11Switch\n        [checked]=\"f[field.name].value\"\n        (changes)=\"f[field.name].setValue($event)\"\n        [label]=\"field.label\"\n        [disabled]=\"disabled\"\n        [disabledText]=\"disabledText\"\n        [size]=\"'sm'\"\n        [loading]=\"loading\"\n      >\n      </e11-switch>\n      <e11-input-errors\n        *ngIf=\"!field.hideInputError\"\n        [formControl]=\"f[field.name]\"\n        [parentForm]=\"form\"\n        [messageOverrides]=\"errorMessageOverrides\"\n      ></e11-input-errors>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"'textarea'\">\n      <e11-textarea\n        #e11TextArea\n        *ngIf=\"field.inputType === 'textarea'\"\n        [label]=\"field.label\"\n        [parentForm]=\"form\"\n        [formControlName]=\"field.name\"\n        [loading]=\"loading\"\n      ></e11-textarea>\n      <e11-input-errors\n        *ngIf=\"!field.hideInputError\"\n        [formControl]=\"f[field.name]\"\n        [parentForm]=\"form\"\n        [messageOverrides]=\"errorMessageOverrides\"\n      ></e11-input-errors>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'file'\">\n      <e11-input-file\n        #e11InputFile\n        *ngIf=\"field.inputType === 'file'\"\n        [formControlName]=\"field.name\"\n        [label]=\"field.label\"\n        [disabled]=\"disabled\"\n        [parentForm]=\"form\"\n        [loading]=\"loading\"\n      ></e11-input-file>\n      <e11-input-errors\n        *ngIf=\"!field.hideInputError\"\n        [formControl]=\"f[field.name]\"\n        [parentForm]=\"form\"\n        [messageOverrides]=\"errorMessageOverrides\"\n      ></e11-input-errors>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'surveyScore'\">\n      <e11-survey-score\n        *ngIf=\"field.inputType === 'surveyScore'\"\n        #e11SurveyScore\n        [parentForm]=\"form\"\n        [question]=\"field.options?.[0]\"\n        [formControlName]=\"field.name\"\n        [loading]=\"loading\"\n        [disabled]=\"disabled\"\n      >\n      </e11-survey-score>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"'dynamic'\">\n      <e11-dynamic-component-generator\n        #e11InputDynamic\n        *ngIf=\"field.inputType === 'dynamic'\"\n        [component]=\"field.extraInputOption!.component!\"\n        [formControlName]=\"field.name\"\n        [loading]=\"loading\"\n      ></e11-dynamic-component-generator>\n    </ng-container>\n  </div>\n  <!-- <ng-container *ngIf=\"field.nestedFormFields\" > -->\n  <e11-field-builder\n    *ngFor=\"let nestedField of field.nestedFormFields\"\n    [field]=\"nestedField\"\n    [form]=\"form\"\n    [loading]=\"loading\"\n    [disabled]=\"disabled\"\n    [disabledText]=\"disabledText\"\n  ></e11-field-builder>\n  <!-- </ng-container> -->\n</div>\n" }]
        }], ctorParameters: () => [], propDecorators: { e11Input: [{
                type: ViewChild,
                args: ['e11Input']
            }], e11InputRadio: [{
                type: ViewChild,
                args: ['e11InputRadio']
            }], e11InputSelect: [{
                type: ViewChild,
                args: ['e11InputSelect']
            }], e11InlineInputSelect: [{
                type: ViewChild,
                args: ['e11InlineInputSelect']
            }], e11InputMultiSelect: [{
                type: ViewChild,
                args: ['e11InputMultiSelect']
            }], e11InputMultiSelector: [{
                type: ViewChild,
                args: ['e11InputMultiSelector']
            }], e11SurveySelector: [{
                type: ViewChild,
                args: ['e11SurveySelector']
            }], e11InputCheckBox: [{
                type: ViewChild,
                args: ['e11InputCheckBox']
            }], e11InputCode: [{
                type: ViewChild,
                args: ['e11InputCode']
            }], e11InputPhone: [{
                type: ViewChild,
                args: ['e11InputPhone']
            }], e11Autocomplete: [{
                type: ViewChild,
                args: ['e11Autocomplete']
            }], e11Switch: [{
                type: ViewChild,
                args: ['e11Switch']
            }], e11TextArea: [{
                type: ViewChild,
                args: ['e11TextArea']
            }], e11InputFile: [{
                type: ViewChild,
                args: ['e11InputFile']
            }], e11InputDatePicker: [{
                type: ViewChild,
                args: ['e11InputDatePicker']
            }], e11InputDynamic: [{
                type: ViewChild,
                args: ['e11InputDynamic']
            }], e11SurveyScore: [{
                type: ViewChild,
                args: ['e11SurveyScore']
            }], field: [{
                type: Input,
                args: [{ required: true }]
            }], form: [{
                type: Input,
                args: [{ required: true }]
            }], loading: [{
                type: Input
            }], disabled: [{
                type: Input
            }], disabledText: [{
                type: Input
            }], errorMessageOverrides: [{
                type: Input
            }] } });

/**
 * Filter templates by position. Default position is 'top' if not specified
 * @param templates
 * @param position
 */
class FilterFormTemplateSpecPipe {
    transform(templates, position) {
        if (isArray(templates)) {
            return templates.filter((template) => template.templatePosition === position || (position === 'top' && !template.templatePosition));
        }
        return templates.templatePosition === position || (position === 'top' && !templates.templatePosition) ? [templates] : [];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: FilterFormTemplateSpecPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: FilterFormTemplateSpecPipe, name: "filterFormTemplateSpec" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: FilterFormTemplateSpecPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'filterFormTemplateSpec',
                }]
        }] });

class E11LayoutTemplateSpecComponent {
    constructor() {
        this.position = 'top';
        this.e11TemplateMap = {};
    }
    trackByTemplateIndex(index, template) {
        return `${template.templateKey}-${template.templatePosition}`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11LayoutTemplateSpecComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: E11LayoutTemplateSpecComponent, selector: "e11-layout-template-spec", inputs: { templateSpec: "templateSpec", position: "position", e11TemplateMap: "e11TemplateMap" }, ngImport: i0, template: ` <ng-container *ngIf="templateSpec">
    <ng-container *ngFor="let template of templateSpec | filterFormTemplateSpec : position; trackBy: trackByTemplateIndex">
      <ng-container *ngTemplateOutlet="e11TemplateMap[template.templateKey]"></ng-container>
    </ng-container>
  </ng-container>`, isInline: true, dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "pipe", type: FilterFormTemplateSpecPipe, name: "filterFormTemplateSpec" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11LayoutTemplateSpecComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'e11-layout-template-spec',
                    template: ` <ng-container *ngIf="templateSpec">
    <ng-container *ngFor="let template of templateSpec | filterFormTemplateSpec : position; trackBy: trackByTemplateIndex">
      <ng-container *ngTemplateOutlet="e11TemplateMap[template.templateKey]"></ng-container>
    </ng-container>
  </ng-container>`,
                }]
        }], propDecorators: { templateSpec: [{
                type: Input
            }], position: [{
                type: Input
            }], e11TemplateMap: [{
                type: Input
            }] } });

class E11DynamicFormBuilderComponent extends E11TemplateMap {
    set submitButtonConfig(value) {
        this._submitButtonConfig = this.calculateConfig(this._submitButtonConfig, value);
    }
    set cancelButtonConfig(value) {
        this._cancelButtonConfig = this.calculateConfig(this._cancelButtonConfig, value);
    }
    set deleteButtonConfig(value) {
        this._deleteButtonConfig = this.calculateConfig(this._deleteButtonConfig, value);
    }
    set cancelLinkConfig(value) {
        this._cancelLinkConfig = this.calculateConfig(this._cancelLinkConfig, value);
    }
    /**
     * @deprecated Use {@link cancelLinkConfig} instead
     */
    set showCancelLink(value) {
        this._cancelLinkConfig = this.calculateConfig(this._cancelLinkConfig, { show: value });
    }
    /**
     * @deprecated Use {@link cancelButtonConfig} instead
     */
    set showCancelButton(value) {
        this._cancelButtonConfig = this.calculateConfig(this._cancelButtonConfig, { show: value });
    }
    /**
     * @deprecated Use {@link deleteButtonConfig} instead
     */
    set showDeleteButton(value) {
        this._deleteButtonConfig = this.calculateConfig(this._deleteButtonConfig, { show: value });
    }
    /**
     * @deprecated Use {@link submitButtonConfig} instead
     */
    set submitButtonTitle(value) {
        this._submitButtonConfig = this.calculateConfig(this._submitButtonConfig, { value });
    }
    /**
     * @deprecated Use {@link cancelLinkConfig} instead
     */
    set cancelLinkTitle(value) {
        this._cancelLinkConfig = this.calculateConfig(this._cancelLinkConfig, { value });
    }
    /**
     * @deprecated Use {@link cancelButtonConfig} instead
     */
    set cancelButtonTitle(value) {
        this._cancelButtonConfig = this.calculateConfig(this._cancelButtonConfig, { value });
    }
    /**
     * @deprecated Use {@link deleteButtonConfig} instead
     */
    set deleteButtonTitle(value) {
        this._deleteButtonConfig = this.calculateConfig(this._deleteButtonConfig, { value });
    }
    /**
     * @deprecated Use {@link submitButtonConfig} instead
     */
    set buttonColorSubmit(value) {
        this._submitButtonConfig = this.calculateConfig(this._submitButtonConfig, { color: value });
    }
    /**
     * @deprecated Use {@link cancelButtonConfig} instead
     */
    set buttonColorCancel(value) {
        this._cancelButtonConfig = this.calculateConfig(this._cancelButtonConfig, { color: value });
    }
    /**
     * @deprecated Use {@link deleteButtonConfig} instead
     */
    set buttonColorDelete(value) {
        this._deleteButtonConfig = this.calculateConfig(this._deleteButtonConfig, { color: value });
    }
    set fieldGroups(value) {
        this._fieldGroups = value.props;
        this.setUpFieldsToForm(this._fieldGroups);
        this.form.setValidators(value.dynamicFormOptions?.validatorOrOpts || []);
    }
    constructor(changeDetector) {
        super();
        this.changeDetector = changeDetector;
        this._fieldGroups = [];
        this.form = new FormGroup({});
        this.hideSubmitMenu = false;
        this.loading = false;
        this.disabled = false;
        this.disabledText = 'This form is disabled';
        this._submitButtonConfig = SUBMIT_BUTTON_DEFAULT_CONFIG;
        this._cancelButtonConfig = CANCEL_BUTTON_DEFAULT_CONFIG;
        this._deleteButtonConfig = DELETE_BUTTON_DEFAULT_CONFIG;
        this._cancelLinkConfig = CANCEL_LINK_DEFAULT_CONFIG;
        this.valueChanges = this.form.valueChanges.pipe(debounceTime(70));
        this.onSubmit = new EventEmitter();
        this.onCancel = new EventEmitter();
        this.onDelete = new EventEmitter();
        this.collectAllNestedFields = (layouts) => {
            let fields = [];
            layouts.forEach((layout) => {
                fields = [...fields, ...layout.fields];
                if (layout.layouts) {
                    fields = [...fields, ...this.collectAllNestedFields(layout.layouts)];
                }
            });
            return fields;
        };
    }
    ngOnChanges(changes) {
        this.setInitialValue();
    }
    addFormControl(field) {
        const { name, inputType, defaultValue, validatorOrOpts, options, valueChange, nestedFormFields, isDisabled } = field;
        const initialValue = this.initialValue && this.initialValue[name];
        let controlValue = null;
        if (defaultValue !== undefined) {
            controlValue = defaultValue;
        }
        else if (this.initialValue !== undefined && this.initialValue.hasOwnProperty(name)) {
            controlValue = initialValue;
        }
        if (inputType !== 'checkbox') {
            const control = new FormControl({ value: controlValue, disabled: isDisabled ?? false }, validatorOrOpts);
            this.form.addControl(name, control);
            if (valueChange) {
                valueChange(control.valueChanges);
            }
        }
        else {
            options?.forEach((opt) => {
                const optionValue = this.initialValue && this.initialValue.hasOwnProperty(opt.value) && this.initialValue[opt.value];
                this.form.addControl(opt.value, new FormControl(optionValue || null, validatorOrOpts));
            });
        }
        if (nestedFormFields) {
            nestedFormFields.forEach((nestedField) => this.addFormControl(nestedField));
        }
    }
    setUpFieldsToForm(value) {
        this.clearFormControls(); // Need to clear form controls before creating new ones
        this.collectAllNestedFields(value).forEach((field) => this.addFormControl(field));
        this.changeDetector.detectChanges();
    }
    setFieldValues(initialValue, form, name, defaultValue) {
        const control = form.get(name);
        if (!control)
            return;
        if (initialValue && initialValue.hasOwnProperty(name)) {
            control.setValue(initialValue[name]);
        }
        else if (defaultValue !== undefined) {
            control.setValue(defaultValue);
        }
        else {
            control.reset();
        }
        control.setErrors(null);
    }
    reset(newValue) {
        this.form.reset(newValue, { emitEvent: false });
    }
    setInitialValue() {
        this.collectAllNestedFields(this._fieldGroups).forEach((field) => {
            this.setFormDataValues(field);
        });
    }
    setFormDataValues(field) {
        const { inputType, options, defaultValue } = field;
        if (!this.initialValue)
            return;
        if (inputType !== 'checkbox' && this.initialValue) {
            this.setFieldValues(this.initialValue, this.form, field.name, defaultValue);
        }
        else {
            options?.forEach((opt) => {
                this.setFieldValues(this.initialValue, this.form, opt.value, defaultValue);
            });
        }
    }
    clearValidation() {
        Object.keys(this.form.controls).forEach((key) => {
            this.form.controls[key].reset();
            this.form.controls[key].setErrors(null);
        });
        this.form.setErrors(null);
        this.form.markAsUntouched();
    }
    onSubmitClick() {
        this.form.updateValueAndValidity();
        Validation.validateAll(this.form);
        if (!this.form.valid) {
            // trigger if not valid
            this.changeDetector.detectChanges();
            return;
        }
        this.onSubmit.emit(this.form.value);
    }
    clearFormControls() {
        Object.keys(this.form.controls).forEach((c) => this.form.removeControl(c));
    }
    calculateConfig(defaultConfig, localConfig) {
        return Object.assign({}, defaultConfig, localConfig);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11DynamicFormBuilderComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.13", type: E11DynamicFormBuilderComponent, selector: "e11-dynamic-form-builder", inputs: { initialValue: "initialValue", hideSubmitMenu: "hideSubmitMenu", loading: "loading", disabled: "disabled", disabledText: "disabledText", submitButtonConfig: "submitButtonConfig", cancelButtonConfig: "cancelButtonConfig", deleteButtonConfig: "deleteButtonConfig", cancelLinkConfig: "cancelLinkConfig", showCancelLink: "showCancelLink", showCancelButton: "showCancelButton", showDeleteButton: "showDeleteButton", submitButtonTitle: "submitButtonTitle", cancelLinkTitle: "cancelLinkTitle", cancelButtonTitle: "cancelButtonTitle", deleteButtonTitle: "deleteButtonTitle", buttonColorSubmit: "buttonColorSubmit", buttonColorCancel: "buttonColorCancel", buttonColorDelete: "buttonColorDelete", fieldGroups: "fieldGroups", errorMessageOverrides: "errorMessageOverrides" }, outputs: { valueChanges: "valueChanges", onSubmit: "onSubmit", onCancel: "onCancel", onDelete: "onDelete" }, usesInheritance: true, usesOnChanges: true, ngImport: i0, template: ` <form name="dynamic-form" (ngSubmit)="onSubmitClick()" [formGroup]="form" class="e11-w-full">
    <ng-template #recursiveList let-fieldSet>
      <e11-layout-template-spec
        *ngIf="fieldSet.templateSpec && (fieldSet.templateSpec | filterFormTemplateSpec : 'top').length"
        [templateSpec]="fieldSet.templateSpec"
        [position]="'top'"
        [e11TemplateMap]="e11TemplateMap"
      >
      </e11-layout-template-spec>
      <div class="{{ fieldSet.containerClass }} ">
        <e11-layout-template-spec
          *ngIf="fieldSet.templateSpec && (fieldSet.templateSpec | filterFormTemplateSpec : 'left').length"
          [templateSpec]="fieldSet.templateSpec"
          [position]="'left'"
          [e11TemplateMap]="e11TemplateMap"
        >
        </e11-layout-template-spec>
        <div class="{{ fieldSet.fieldsClass }}" *ngFor="let field of fieldSet.fields">
          <e11-field-builder
            *ngIf="field?.inputType && !field.isHidden"
            [field]="field"
            [form]="form"
            [loading]="loading"
            [disabled]="disabled"
            [disabledText]="disabledText"
          ></e11-field-builder>
        </div>
        @if (fieldSet.layouts && fieldSet.layouts.length > 0) {
        <div class="{{ fieldSet.layoutContainerClass }}">
          <ng-container *ngFor="let fieldSetLayout of fieldSet.layouts">
            <ng-container *ngTemplateOutlet="recursiveList; context: { $implicit: fieldSetLayout }"></ng-container>
          </ng-container>
        </div>
        }
      </div>
      <e11-layout-template-spec
        *ngIf="fieldSet.templateSpec && (fieldSet.templateSpec | filterFormTemplateSpec : 'bottom').length"
        [templateSpec]="fieldSet.templateSpec"
        [position]="'bottom'"
        [e11TemplateMap]="e11TemplateMap"
      ></e11-layout-template-spec>
    </ng-template>
    <ng-container *ngFor="let fieldSet of _fieldGroups">
      <ng-container *ngTemplateOutlet="recursiveList; context: { $implicit: fieldSet }"></ng-container>
    </ng-container>

    <div class="e11-flex e11-justify-between" *ngIf="!hideSubmitMenu">
      <div class="col-md-3"></div>
      <div class="e11-flex e11-items-center e11-gap-2">
        <a
          *ngIf="_cancelLinkConfig.show"
          (click)="onCancel.emit()"
          class="e11-cancel-link e11-mr-2 e11-cursor-pointer e11-text-skin-light hover:e11-text-skin-primary"
          >{{ _cancelLinkConfig.value }}</a
        >
        <e11-button
          *ngIf="_cancelButtonConfig.show"
          [value]="_cancelButtonConfig.value"
          [color]="_cancelButtonConfig.color"
          [size]="_cancelButtonConfig.size"
          [ghost]="true"
          (click)="onCancel.emit()"
        ></e11-button>
        <e11-button
          *ngIf="_deleteButtonConfig.show"
          [value]="_deleteButtonConfig.value"
          [color]="_deleteButtonConfig.color"
          [size]="_deleteButtonConfig.size"
          [ghost]="true"
          (click)="onDelete.emit()"
        ></e11-button>
        <e11-button
          type="submit"
          [value]="_submitButtonConfig.value"
          [color]="_submitButtonConfig.color"
          [size]="_submitButtonConfig.size"
          [loading]="_submitButtonConfig.loading"
          [disabled]="disabled"
          [disabledText]="disabledText"
        ></e11-button>
      </div>
    </div>
  </form>`, isInline: true, dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: i3$1.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "component", type: E11FieldBuilderComponent, selector: "e11-field-builder", inputs: ["field", "form", "loading", "disabled", "disabledText", "errorMessageOverrides"] }, { kind: "component", type: E11LayoutTemplateSpecComponent, selector: "e11-layout-template-spec", inputs: ["templateSpec", "position", "e11TemplateMap"] }, { kind: "pipe", type: FilterFormTemplateSpecPipe, name: "filterFormTemplateSpec" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11DynamicFormBuilderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'e11-dynamic-form-builder',
                    template: ` <form name="dynamic-form" (ngSubmit)="onSubmitClick()" [formGroup]="form" class="e11-w-full">
    <ng-template #recursiveList let-fieldSet>
      <e11-layout-template-spec
        *ngIf="fieldSet.templateSpec && (fieldSet.templateSpec | filterFormTemplateSpec : 'top').length"
        [templateSpec]="fieldSet.templateSpec"
        [position]="'top'"
        [e11TemplateMap]="e11TemplateMap"
      >
      </e11-layout-template-spec>
      <div class="{{ fieldSet.containerClass }} ">
        <e11-layout-template-spec
          *ngIf="fieldSet.templateSpec && (fieldSet.templateSpec | filterFormTemplateSpec : 'left').length"
          [templateSpec]="fieldSet.templateSpec"
          [position]="'left'"
          [e11TemplateMap]="e11TemplateMap"
        >
        </e11-layout-template-spec>
        <div class="{{ fieldSet.fieldsClass }}" *ngFor="let field of fieldSet.fields">
          <e11-field-builder
            *ngIf="field?.inputType && !field.isHidden"
            [field]="field"
            [form]="form"
            [loading]="loading"
            [disabled]="disabled"
            [disabledText]="disabledText"
          ></e11-field-builder>
        </div>
        @if (fieldSet.layouts && fieldSet.layouts.length > 0) {
        <div class="{{ fieldSet.layoutContainerClass }}">
          <ng-container *ngFor="let fieldSetLayout of fieldSet.layouts">
            <ng-container *ngTemplateOutlet="recursiveList; context: { $implicit: fieldSetLayout }"></ng-container>
          </ng-container>
        </div>
        }
      </div>
      <e11-layout-template-spec
        *ngIf="fieldSet.templateSpec && (fieldSet.templateSpec | filterFormTemplateSpec : 'bottom').length"
        [templateSpec]="fieldSet.templateSpec"
        [position]="'bottom'"
        [e11TemplateMap]="e11TemplateMap"
      ></e11-layout-template-spec>
    </ng-template>
    <ng-container *ngFor="let fieldSet of _fieldGroups">
      <ng-container *ngTemplateOutlet="recursiveList; context: { $implicit: fieldSet }"></ng-container>
    </ng-container>

    <div class="e11-flex e11-justify-between" *ngIf="!hideSubmitMenu">
      <div class="col-md-3"></div>
      <div class="e11-flex e11-items-center e11-gap-2">
        <a
          *ngIf="_cancelLinkConfig.show"
          (click)="onCancel.emit()"
          class="e11-cancel-link e11-mr-2 e11-cursor-pointer e11-text-skin-light hover:e11-text-skin-primary"
          >{{ _cancelLinkConfig.value }}</a
        >
        <e11-button
          *ngIf="_cancelButtonConfig.show"
          [value]="_cancelButtonConfig.value"
          [color]="_cancelButtonConfig.color"
          [size]="_cancelButtonConfig.size"
          [ghost]="true"
          (click)="onCancel.emit()"
        ></e11-button>
        <e11-button
          *ngIf="_deleteButtonConfig.show"
          [value]="_deleteButtonConfig.value"
          [color]="_deleteButtonConfig.color"
          [size]="_deleteButtonConfig.size"
          [ghost]="true"
          (click)="onDelete.emit()"
        ></e11-button>
        <e11-button
          type="submit"
          [value]="_submitButtonConfig.value"
          [color]="_submitButtonConfig.color"
          [size]="_submitButtonConfig.size"
          [loading]="_submitButtonConfig.loading"
          [disabled]="disabled"
          [disabledText]="disabledText"
        ></e11-button>
      </div>
    </div>
  </form>`,
                }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }], propDecorators: { initialValue: [{
                type: Input
            }], hideSubmitMenu: [{
                type: Input
            }], loading: [{
                type: Input
            }], disabled: [{
                type: Input
            }], disabledText: [{
                type: Input
            }], submitButtonConfig: [{
                type: Input
            }], cancelButtonConfig: [{
                type: Input
            }], deleteButtonConfig: [{
                type: Input
            }], cancelLinkConfig: [{
                type: Input
            }], showCancelLink: [{
                type: Input
            }], showCancelButton: [{
                type: Input
            }], showDeleteButton: [{
                type: Input
            }], submitButtonTitle: [{
                type: Input
            }], cancelLinkTitle: [{
                type: Input
            }], cancelButtonTitle: [{
                type: Input
            }], deleteButtonTitle: [{
                type: Input
            }], buttonColorSubmit: [{
                type: Input
            }], buttonColorCancel: [{
                type: Input
            }], buttonColorDelete: [{
                type: Input
            }], fieldGroups: [{
                type: Input
            }], errorMessageOverrides: [{
                type: Input
            }], valueChanges: [{
                type: Output
            }], onSubmit: [{
                type: Output
            }], onCancel: [{
                type: Output
            }], onDelete: [{
                type: Output
            }] } });

class E11DynamicFormModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11DynamicFormModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: E11DynamicFormModule, declarations: [E11DynamicFormBuilderComponent,
            E11FieldBuilderComponent,
            SwitchCasesDirective,
            FilterFormTemplateSpecPipe,
            E11LayoutTemplateSpecComponent,
            E11DynamicComponentGeneratorComponent], imports: [CommonModule,
            E11ModalModule,
            ReactiveFormsModule,
            E11ButtonModule,
            E11InputModule,
            E11InputErrorsModule,
            E11InputCheckboxModule,
            E11RadioInputModule,
            E11SelectModule,
            E11InputCodeModule,
            E11PhoneNumberModule,
            E11MultiSelectModule,
            E11MultiSelectorModule,
            E11AutocompleteModule,
            E11UtilModule,
            E11SwitchModule,
            E11TextareaModule,
            E11InputFileModule,
            E11SurveyScoreComponent,
            E11SurveySelectorComponent,
            E11DatePickerModule,
            E11InlineSelectComponent], exports: [E11DynamicFormBuilderComponent, E11FieldBuilderComponent, E11DynamicComponentGeneratorComponent, SwitchCasesDirective, E11UtilModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11DynamicFormModule, imports: [CommonModule,
            E11ModalModule,
            ReactiveFormsModule,
            E11ButtonModule,
            E11InputModule,
            E11InputErrorsModule,
            E11InputCheckboxModule,
            E11RadioInputModule,
            E11SelectModule,
            E11InputCodeModule,
            E11PhoneNumberModule,
            E11MultiSelectModule,
            E11MultiSelectorModule,
            E11AutocompleteModule,
            E11UtilModule,
            E11SwitchModule,
            E11TextareaModule,
            E11InputFileModule,
            E11SurveyScoreComponent,
            E11SurveySelectorComponent,
            E11DatePickerModule,
            E11InlineSelectComponent, E11UtilModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11DynamicFormModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        E11ModalModule,
                        ReactiveFormsModule,
                        E11ButtonModule,
                        E11InputModule,
                        E11InputErrorsModule,
                        E11InputCheckboxModule,
                        E11RadioInputModule,
                        E11SelectModule,
                        E11InputCodeModule,
                        E11PhoneNumberModule,
                        E11MultiSelectModule,
                        E11MultiSelectorModule,
                        E11AutocompleteModule,
                        E11UtilModule,
                        E11SwitchModule,
                        E11TextareaModule,
                        E11InputFileModule,
                        E11SurveyScoreComponent,
                        E11SurveySelectorComponent,
                        E11DatePickerModule,
                        E11InlineSelectComponent,
                    ],
                    exports: [E11DynamicFormBuilderComponent, E11FieldBuilderComponent, E11DynamicComponentGeneratorComponent, SwitchCasesDirective, E11UtilModule],
                    declarations: [
                        E11DynamicFormBuilderComponent,
                        E11FieldBuilderComponent,
                        SwitchCasesDirective,
                        FilterFormTemplateSpecPipe,
                        E11LayoutTemplateSpecComponent,
                        E11DynamicComponentGeneratorComponent,
                    ],
                    providers: [],
                }]
        }] });

/**
 * Generate a layout object that will hold fields in a list
 * One field per row
 *
 * @param fields
 * @param containerClass
 * @param fieldsClass
 * @returns
 */
function e11FormLayout(fields, layoutOpts) {
    return {
        ...layoutOpts,
        containerClass: `${layoutOpts?.containerClass}`,
        fieldsClass: `${layoutOpts?.fieldsClass}`,
        fields,
    };
}
/**
 * Generate a layout object that will hold fields in a list
 * One field per row
 *
 * the same as {@link e11FormLayout}
 *
 * @param fields
 * @param containerClass
 * @param fieldsClass
 * @returns
 */
function e11FormLayoutFullWidth(fields, layoutOpts) {
    return e11FormLayout(fields, layoutOpts);
}
/**
 * Generate a layout object that will hold fields in a grid
 * @param fields - {@type DynamicFieldData[]}
 * @param containerClass
 * @param fieldsClass
 * @returns - {@link FieldsGroupLayout} generate a dynamic layout group for list of fields
 */
function e11FormLayoutInlineGrid(fields, layoutOpts) {
    return {
        ...layoutOpts,
        containerClass: `e11-flex e11-justify-between e11-gap-4 ${layoutOpts?.containerClass ?? ''}`,
        fieldsClass: `${layoutOpts?.fieldsClass ?? 'e11-w-full'}`,
        fields,
    };
}
/**
 * Generate a layout object that will hold fields in 3 column and wraps overflow
 * @param fields
 * @param layoutOpts
 * @returns - {@link FieldsGroupLayout} generate a dynamic layout group for list of fields
 */
function e11FormLayoutInline3Grid(fields, layoutOpts) {
    return e11FormLayoutInlineGrid(fields, {
        ...layoutOpts,
        containerClass: `e11-flex-wrap e11-border-b e11-mb-4 e11-gap-0 ${layoutOpts?.containerClass ?? ''}`,
        fieldsClass: `e11-w-full md:e11-w-[45%] lg:e11-w-[30%] ${layoutOpts?.fieldsClass ?? ''}`,
    });
}
/**
 * Generate a layout object that will hold fields in a group
 * @param layouts Array of layout objects
 * @param layoutOpts Additional layout options
 * @returns
 */
function e11LayoutGroup(layouts, layoutOpts) {
    return {
        layouts,
        fields: [],
        ...layoutOpts,
    };
}
/**
 *
 * @param inputType {@link InputTypes} different list of input types like 'text' | 'number' ...
 * @param name name of input element
 * @param label human readable label, potentially translated
 * @param defaultValue initial value, potentially null
 * @param options List of extra option like valueChange | validators []
 * @returns - {@link DynamicFieldData} - The generated dynamic field data
 */
function e11Field(inputType, name, label, defaultValue, options) {
    const { validatorOrOpts, valueChange, extraInputOption, nestedFormFields, isHidden, hideInputError, isDisabled } = options || {};
    return {
        id: '',
        inputType,
        validatorOrOpts,
        valueChange,
        name,
        defaultValue,
        label,
        extraInputOption,
        nestedFormFields,
        isHidden,
        hideInputError,
        isDisabled,
    };
}
/**
 * Generates a color dynamic field input compliant object
 * @param name name of color input element
 * @param label human readable label, potentially translated
 * @param defaultValue initial value potentially null
 * @param options List of extra option like valueChange | validators []
 * @returns - {@link DynamicFieldData} - The generated dynamic field data
 */
function e11FieldInputColor(name, label, defaultValue, options) {
    return e11Field('color', name, label, defaultValue, options);
}
/**
 * Generates a dynamic text field input
 *
 * @param name name of text input element
 * @param label human readable label, potentially translated
 * @param defaultValue initial value potentially null
 * @param options List of extra option like valueChange | validators []
 * @returns - {@link DynamicFieldData} - The generated dynamic field object for text input
 */
function e11FieldInputText(name, label, defaultValue, options) {
    return e11Field('text', name, label, defaultValue, options);
}
/**
 * Generates a dynamic url field input
 *
 * @param name name of url input element
 * @param label human readable label, potentially translated
 * @param defaultValue initial value potentially null
 * @param options List of extra option like valueChange | validators []
 * @returns - {@link DynamicFieldData} - The generated dynamic field object for url input
 */
function e11FieldInputUrl(name, label, defaultValue, options) {
    return e11Field('url', name, label, defaultValue, options);
}
/**
 * Generates a dynamic code field input
 *
 * @param name name of code input element
 * @param label human readable label, potentially translated
 * @param defaultValue initial value potentially null
 * @param options List of extra option like valueChange | validators []
 * @returns - {@link DynamicFieldData} - The generated dynamic field object for code input
 */
function e11FieldInputCode(name, label, defaultValue, options) {
    return e11Field('code', name, label, defaultValue, options);
}
/**
 * Generates a number dynamic field input compliant object
 * @param name name of input number element
 * @param label human readable label, potentially translated
 * @param defaultValue initial value potentially null
 * @param options List of extra option like valueChange | validators []
 * @returns - {@link DynamicFieldData} - The generated dynamic field object for number
 */
function e11FieldInputNumber(name, label, defaultValue, options) {
    return e11Field('number', name, label, defaultValue, options);
}
/**
 * Generates a drop down select dynamic field input compliant object
 * @param name name of input select element
 * @param label human readable label, potentially translated
 * @param options - {@link ISelectOption } List of the drop down options
 * @param defaultValue initial value potentially null
 * @param extraOptions List of extra option like valueChange | validators []
 * @returns - {@link DynamicFieldData} - The generated dynamic field object for select input
 */
function e11FieldInputSelect(name, label, options, defaultValue, extraOptions) {
    return {
        ...e11Field('select', name, label, defaultValue, extraOptions),
        options,
    };
}
function e11FieldInlineInputSelect(name, options, label, defaultValue, extraOptions) {
    return {
        ...e11Field('inlineSelect', name, label, defaultValue, extraOptions),
        options,
    };
}
/**
 *
 * @param name name of input multi select element
 * @param label human readable label, potentially translated
 * @param options - {@link IMultiSelectOption } List of the multi select options
 * @param defaultValue initial value potentially null
 * @param extraOptions List of extra option like valueChange | validators []
 * @returns - {@link DynamicFieldData} - The generated dynamic field object for multi select input
 */
function e11FieldInputMultiSelect(name, label, options, defaultValue, extraOptions) {
    return {
        ...e11Field('multiSelect', name, label, defaultValue, extraOptions),
        options,
    };
}
/**
 *
 * @param name name of input date picker element
 * @param label human readable label, potentially translated
 * @param defaultValue initial value potentially null
 * @param extraOptions List of extra option like valueChange | validators []
 * @returns - {@link DynamicFieldData} - The generated dynamic field object for multi select input
 */
function e11FieldInputDatePicker(name, label, defaultValue, extraOptions) {
    return {
        ...e11Field('datePicker', name, label, defaultValue, extraOptions),
    };
}
/**
 *
 * @param name name of input multi selector element
 * @param label human readable label, potentially translated
 * @param options - {@link IMultiSelectorOption } List of the multi selector options
 * @param defaultValue initial value potentially null
 * @param extraOptions List of extra option like valueChange | validators []
 * @returns - {@link DynamicFieldData} - The generated dynamic field object for multi selector input
 */
function e11FieldInputMultiSelector(name, label, options, defaultValue, extraOptions) {
    return {
        ...e11Field('multiSelector', name, label, defaultValue, extraOptions),
        options,
    };
}
/**
 *
 * @param name name of input survey selector element
 * @param question - {@link E11SurveyQuestionSelector } Survey question object
 * @param defaultValue initial value potentially null
 * @param extraOptions List of extra option like valueChange | validators []
 * @returns - {@link DynamicFieldData} - The generated dynamic field object for survey selector input
 */
function e11FieldInputSurveySelector(name, question, defaultValue, extraOptions) {
    return {
        ...e11Field('surveySelector', name, undefined, defaultValue, extraOptions),
        options: [question],
    };
}
/**
 *
 * @param name name of input autocomplete element
 * @param label human readable label, potentially translated
 * @param options - {@link ISelectOption } List of the drop down options
 * @param defaultValue  initial value potentially null
 * @param extraOptions List of extra option like valueChange | validators []
 * @returns - {@link DynamicFieldData} - The generated dynamic field object for autocomplete input
 */
function e11FieldInputAutocomplete(name, label, options, defaultValue, extraOptions) {
    return {
        ...e11Field('autocomplete', name, label, defaultValue, extraOptions),
        options,
    };
}
/**
 * Generates a check box dynamic field input compliant object
 * @param name name of input check box element
 * @param label human readable label, potentially translated
 * @param options - {@link ISelectOption } List of the drop down options
 * @param defaultValue initial value potentially null
 * @param extraOptions List of extra option like valueChange | validators []
 * @returns - {@link DynamicFieldData} - The generated dynamic field object for select input
 */
function e11FieldInputCheckBox(name, label, options, defaultValue, extraOptions) {
    return {
        ...e11Field('checkbox', name, label, defaultValue, extraOptions),
        options,
    };
}
/**
 * Generates a radio box dynamic field input compliant object
 * @param name name of input check box element
 * @param label human readable label, potentially translated
 * @param options {@link ISelectOption } List of the radio box options
 * @param defaultValue initial value potentially null
 * @param extraOptions List of extra option like valueChange | validators []
 * @returns - {@link DynamicFieldData} - The generated dynamic field object for select input
 */
function e11FieldInputRadio(name, label, options, defaultValue, extraOptions) {
    return {
        ...e11Field('radio', name, label, defaultValue, extraOptions),
        options,
    };
}
/**
 * Generates a phone number dynamic field input compliant object
 * @param name name of input check box element
 * @param label human readable label, potentially translated
 * @param options {@link ISelectOption } List of the radio box options
 * @param defaultValue initial value potentially null
 * @param options List of extra option like valueChange | validators []
 * @returns - {@link DynamicFieldData} - The generated dynamic field object for select input
 */
function e11FieldInputPhone(name, label, defaultValue, options) {
    return e11Field('phone', name, label, defaultValue, options);
}
/**
 * Generates a switch dynamic field input compliant object
 * @param name name of switch input element
 * @param label human readable label, potentially translated
 * @param defaultValue initial value potentially null
 * @param options List of extra option like valueChange | validators []
 * @returns - {@link DynamicFieldData} - The generated dynamic field data
 */
function e11FieldInputSwitch(name, label, defaultValue, options) {
    return e11Field('switch', name, label, defaultValue, options);
}
/**
 *
 * @param name name of input text area element
 * @param label human readable label, potentially translated
 * @param defaultValue initial value potentially null
 * @param options List of extra option like valueChange | validators []
 * @returns - {@link DynamicFieldData} - The generated dynamic field data
 */
function e11FieldInputTextArea(name, label, defaultValue, options) {
    return e11Field('textarea', name, label, defaultValue, options);
}
/**
 *
 * @param name name of input file element
 * @param label human readable label, potentially translated
 * @param defaultValue initial value potentially null
 * @param options List of extra option like valueChange | validators []
 * @returns - {@link DynamicFieldData} - The generated dynamic field data
 */
function e11FieldInputFile(name, label, defaultValue, options) {
    return e11Field('file', name, label, defaultValue, options);
}
/**
 *
 * @param name name of input survey score element
 * @param question - {@link E11SurveyScoreComponent } score question object
 * @param defaultValue initial value potentially null
 * @param extraOptions List of extra option like valueChange | validators []
 * @returns - {@link DynamicFieldData} - The generated dynamic field data
 */
function e11FieldInputSurveyScore(name, question, defaultValue, extraOptions) {
    return {
        ...e11Field('surveyScore', name, undefined, defaultValue, extraOptions),
        options: [question],
    };
}
/**
 *
 * @param name name of input dynamic component element
 * @param label human readable label, potentially translated
 * @param component dynamic component that will be render in place, should inherit {@link IE11DynamicComponent}
 * @param defaultValue initial value potentially null
 * @param options List of extra option like valueChange | validators []
 * @returns - {@link DynamicFieldData} - The generated dynamic field data
 */
function e11FieldInputDynamicComponent(name, label, component, defaultValue, options) {
    return e11Field('dynamic', name, label, defaultValue, { ...(options || {}), extraInputOption: { component, ...(options?.extraInputOption || {}) } });
}
/**
 *
 * @param callback - The callback function that will be called when the event is emitted
 * @returns - {@link EventEmitter} - The generated event emitter
 */
const e11FormEventHelper = (callback) => {
    return {
        emit: (value) => {
            callback(value);
        },
    };
};
/**
 * Pass a Layout and generate array of form layout with fields that can be type checked by TS
 *
 * Example:
 * interface IUser {
 *  fName: string;
 *  mName: string;
 *  lName: string;
 * }
 *
 * // This is a correct form with layout and fields
 * const userForm = e11FormFor<IUser>()([{
 *          fields: [{ id: '1', name: 'fName', label: 'First Name' }],
 *          layouts: [{ fields: [{ id: '2', name: 'mName', label: 'Middle Name' }, { id: '3', name: 'lName', label: 'Last Name' }] }],
 *        }]);
 *
 * // This is an incorrect form because its missing lName
 * const invalidUserForm = e11FormFor<IUser>()([{
 *      fields: [{ id: '1', name: 'fName', label: 'First Name' }],
 *      layouts: [{ fields: [{ id: '2', name: 'mName', label: 'Middle Name' }] }],
 *      }]);
 *
 * // This is an incorrect form because its missing lName and mName
 * const invalidUserFormEmptyLayouts = e11FormFor<IUser>()([{
 *    fields: [{ id: '1', name: 'fName', label: 'First Name' }],
 * }]);
 *
 * @returns - {@link E11FormForType}
 */
function e11FormFor(dynamicFormOptions) {
    return function (props) {
        return { props, dynamicFormOptions };
    };
}

/**
 * Generated bundle index. Do not edit.
 */

export { E11DynamicComponentGeneratorComponent, E11DynamicFormBuilderComponent, E11DynamicFormModule, E11FieldBuilderComponent, SwitchCasesDirective, e11Field, e11FieldInlineInputSelect, e11FieldInputAutocomplete, e11FieldInputCheckBox, e11FieldInputCode, e11FieldInputColor, e11FieldInputDatePicker, e11FieldInputDynamicComponent, e11FieldInputFile, e11FieldInputMultiSelect, e11FieldInputMultiSelector, e11FieldInputNumber, e11FieldInputPhone, e11FieldInputRadio, e11FieldInputSelect, e11FieldInputSurveyScore, e11FieldInputSurveySelector, e11FieldInputSwitch, e11FieldInputText, e11FieldInputTextArea, e11FieldInputUrl, e11FormEventHelper, e11FormFor, e11FormLayout, e11FormLayoutFullWidth, e11FormLayoutInline3Grid, e11FormLayoutInlineGrid, e11LayoutGroup };
